const config = {
  url: import.meta.env.VITE_SITE_URL,
  api: import.meta.env.VITE_API_BASE,
  trpc: import.meta.env.VITE_TRPC_URL,
  socketURL: import.meta.env.VITE_SOCKET_URL,
  cognito: {
    poolID: import.meta.env.VITE_COGNITO_POOL_ID,
    appID: import.meta.env.VITE_COGNITO_APP_ID,
  },
  maintenanceMode: import.meta.env.VITE_MAINTENANCE_MODE,
  maintenanceModeCode: import.meta.env.VITE_MAINTENANCE_MODE_CODE,
} as const;

export default config;
